import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

import { messageModels } from '..';

export const useNikitaCheckSave = () =>
  useMutation<any, any, messageModels.INikitaCheck>(
    async data => {
      const res = await $api.post('/v1/nikita/check', data);

      return res.data;
    },
    {
      onSuccess: data => {
        showMessage(data.message, data.accept);
      }
    }
  );
